module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-loader"
  }, [_c('transition-group', {
    staticClass: "dot-container",
    attrs: {
      "name": "dot-bounce",
      "tag": "div"
    }
  }, _vm._l((_vm.dotColors), function(dotColor, index) {
    return _c('div', {
      key: index,
      staticClass: "dot"
    })
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f7ba570e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/MyLoader.vue
// module id = 836
// module chunks = 0